export default {
  methods: {
    matchingDoc(vehicle, doc) {
      if (vehicle && vehicle.Aaa && doc && doc.Cnit && doc.Mine_type) {
        // Check if document is not validated
        if (doc.Document && doc.Document.status_document_id && doc.Document.status_document_id == '2') { return '1'; }
        // Check among validated cnit & mine_type
        const findCnit = doc.Cnit.map(e => ({ label: e.label, valid: e.is_valid })).find(e => e.label == vehicle.Aaa.cnit && e.valid);
        const findMine = doc.Mine_type.map(e => ({ label: e.label, valid: e.is_valid })).find(e => e.label == vehicle.Aaa.mine && e.valid);
        // Check if there is a correspondance between vehicle's cnit or mine & document data
        if (findCnit === undefined && findMine !== undefined) return '2';
        if (findCnit !== undefined) return '3';
        return '1';
      }
    },
    getSpeedometerValue(value) {
      if (value == '1') return '65';
      if (value == '2') return '80';
      if (value == '3') return '99';
    },
    getSpeedometerLabel(value) {
      if (value == '65') return '1';
      if (value == '80') return '2';
      if (value == '99') return '3';
    }
  }
};
